/** Skip Netlify admin sync when the tab is hidden or the window does not have focus (saves quota on long sessions). */
export function shouldDeferAdminFetch(): boolean {
  if (typeof document === "undefined") return false;
  return document.visibilityState !== "visible" || !document.hasFocus();
}
